import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  Text,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineShopping } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import FetchData from "../../services/FetchData";
import DetailTransaction from "../modals/DetailTransaction";
import QRIS from "../../assets/payment/qris.png";
import BPD from "../../assets/payment/bank-bpd.png";

export default function TransactionCard({ data }) {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [mobile] = useMediaQuery("(max-width: 600px)");
  const payment = data.payment_method;
  const navigate = useNavigate();
  const toast = useToast();

  const [openDetail, setOpenDetail] = useState(false);
  const [openBarang, setOpenBarang] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    setReload(reload + 1);
  }, [data]);

  const { data: data1 } = FetchData({
    url: "/orders/history/" + data?.order_id,
    reload: reload,
  });

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const handleOpenDetail = () => {
    setOpenDetail(true);
  };

  const handelClose = () => {
    setOpenDetail(false);
  };

  const handleCheckPayment = () => {
    axios
      .post(
        baseURL + "/orders/checkpayment",
        {
          order_id: data?.order_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          navigate(payment === "QRIS" ? "/scan-qris" : "/bpd-va", {
            state: res.data?.data,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Error",
          description:
            "Terjadi Kesalahan, mohon reload ulang atau hubungi administrator",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      });
  };

  // console.log(data1);

  return (
    <Box
      border="1px solid #E0E0E0"
      borderRadius="10px"
      p="5"
      boxShadow="md"
      my="5"
    >
      <Text fontSize="16" fontWeight="600">
        {data?.order_status === "Gagal"
          ? "Gagal (Expired)"
          : data?.order_status}
      </Text>
      <Box py={mobile ? "2" : "5"} display="flex" alignItems="center">
        <Box bgColor="#E9EFFD" p="2" borderRadius="full">
          <AiOutlineShopping size={30} style={{ color: "blue" }} />
        </Box>
        <Text fontSize="16" fontWeight="600" px="3">
          Belanja
        </Text>
        <Text fontSize="16" color="#B9B9B9">
          {data?.order_date}
        </Text>
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" py={mobile ? "2" : "5"}>
        <GridItem display="flex" alignItems="center">
          <img
            src={payment === "QRIS" ? QRIS : BPD}
            alt={payment === "QRIS" ? "qris" : "bpd-va"}
            width="100px"
          />
          <Box hidden={mobile} px="5">
            <Text fontSize="14">Metode Pembayaran</Text>
            <Text fontSize="18" fontWeight="600">
              {payment}
            </Text>
          </Box>
        </GridItem>
        <GridItem display="flex" alignItems="center">
          {payment !== "QRIS" && (
            <>
              <Box hidden={mobile} border="1px solid #B9B9B9" h="full"></Box>
              <Box pl={!mobile && "5"}>
                <Text fontSize={mobile ? "12" : "14"}>
                  {mobile ? payment : "Nomor Virtual Account"}
                </Text>
                <Text fontSize={mobile ? "12" : "18"} fontWeight="600">
                  {data?.no_va}
                </Text>
              </Box>
            </>
          )}
        </GridItem>
        <GridItem
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pr={!mobile && "7"}
        >
          <Box border="1px solid #B9B9B9" h="full"></Box>
          <Box pl="5">
            <Text fontSize={mobile ? "12" : "14"}>Total Pembayaran</Text>
            <Text fontSize={mobile ? "12" : "18"} fontWeight="600">
              {IDRConvert.format(data?.grand_total)}
            </Text>
          </Box>
        </GridItem>
      </Grid>

      <Box pb="5">
        <Box display="flex">
          <Text fontWeight="bold">{data1?.seller_name}</Text>
        </Box>
        {data1?.items.map((item, key) => (
          <Grid
            key={key}
            templateColumns="repeat(3, 1fr)"
            borderRadius="10px"
            border="1px solid #E0E0E0"
            p={mobile ? "2" : "5"}
            my="3"
          >
            <GridItem colSpan={2} display="flex">
              <img
                src={item.img}
                alt={item.name}
                style={{
                  borderRadius: "5px",
                  maxWidth: mobile ? "70px" : "100px",
                }}
              />
              <Box
                display="flex"
                flexDir="column"
                justifyContent="center"
                pl="3"
              >
                <Text fontWeight="500" fontSize={mobile ? "12" : "15"}>
                  {item.name}
                </Text>
                <Text fontWeight="400" fontSize={mobile ? "10" : "12"}>
                  {item.qty} Barang
                </Text>
              </Box>
            </GridItem>
            <GridItem display="flex">
              <Box
                hidden={mobile}
                border="1px solid #E0E0E0"
                my={mobile ? "2" : "5"}
              />
              <Box
                display="flex"
                justifyContent="end"
                alignItems="center"
                py={mobile ? "3" : "5"}
                w="full"
              >
                <Box fontSize={mobile ? "12" : "16"}>
                  <Text fontWeight="400">Total Harga</Text>
                  <Text fontWeight="600">
                    {IDRConvert.format(item.subtotal)}
                  </Text>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        ))}
      </Box>
      <HStack display="flex" justifyContent="flex-end" px="3" spacing={6}>
        <Button
          variant="outline"
          colorScheme="blue"
          fontWeight="400"
          size={mobile ? "sm" : "md"}
          onClick={handleOpenDetail}
        >
          Detail Transaksi
        </Button>
        {data?.order_status === "Belum Lunas" && (
          <Button
            colorScheme="blue"
            size={mobile ? "sm" : "md"}
            fontWeight="400"
            onClick={handleCheckPayment}
          >
            Cara Pembayaran
          </Button>
        )}
      </HStack>
      <DetailTransaction
        data={data1}
        isOpen={openDetail}
        onClose={handelClose}
      />
    </Box>
  );
}
